import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Grace period before acting on `shouldRedirect`, so a search debounce/in-flight
// refetch (which can briefly make the list look empty right after a filter is
// cleared) doesn't get mistaken for "genuinely no data" — see useTransactionListing's
// 500ms search debounce, the largest known delay between a filter clearing and the
// matching data actually arriving.
const REDIRECT_GRACE_MS = 700;

// Redirects to `targetRoute` once `shouldRedirect` has been continuously true for
// REDIRECT_GRACE_MS (e.g. a transactions listing has no data at all, instead of
// showing an empty state). If shouldRedirect flips back to false before the grace
// period elapses — because fresh data arrived — the pending redirect is cancelled.
const useEmptyListingRedirect = (shouldRedirect, targetRoute) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!shouldRedirect || !targetRoute) return;

    const timer = setTimeout(() => {
      navigate(targetRoute, { replace: true });
    }, REDIRECT_GRACE_MS);

    return () => clearTimeout(timer);
  }, [shouldRedirect, targetRoute, navigate]);
};

export default useEmptyListingRedirect;
